/**
 * Destiny Virgin Hair — Global Product Card Controller
 * Handles variant selection, dynamic pricing, and AJAX add-to-cart
 * with Section Rendering API cart drawer sync across the entire store.
 */
(function () {
  'use strict';

  // 1. Listen for Variant Selection Changes (Document Delegation)
  document.addEventListener('change', function (event) {
    const select = event.target.closest('[data-card-variant-select]');
    if (!select) return;

    const card = select.closest('[data-product-card]');
    if (!card) return;

    const selectedOption = select.options[select.selectedIndex];
    if (!selectedOption) return;

    const priceEl = card.querySelector('[data-card-price]');
    const addBtn = card.querySelector('[data-card-add-btn]');
    const btnText = addBtn ? (addBtn.querySelector('.destiny-product-card__btn-text') || addBtn) : null;

    const variantId = selectedOption.value;
    const price = selectedOption.getAttribute('data-price');
    const available = selectedOption.getAttribute('data-available') !== 'false';

    // Update displayed price
    if (price && priceEl) {
      priceEl.textContent = price;
    }

    // Update Add to Cart Button target variant ID and availability
    if (addBtn && variantId) {
      addBtn.setAttribute('data-variant-id', variantId);

      // Check if store allows adding sold out or disables button
      const allowSoldOut = addBtn.getAttribute('data-allow-sold-out') === 'true';
      if (!available && !allowSoldOut) {
        addBtn.disabled = true;
        if (btnText) btnText.textContent = 'SOLD OUT';
      } else {
        addBtn.disabled = false;
        if (btnText && btnText.textContent === 'SOLD OUT') {
          btnText.textContent = 'ADD TO CART';
        }
      }
    }
  });

  // 2. Helper: Sync and Open Cart Drawer via Section Rendering API
  async function syncAndOpenCartDrawer() {
    try {
      // Fetch fresh cart drawer HTML from Shopify Section Rendering API
      const response = await fetch('/?section_id=cart-drawer-section');
      if (!response.ok) return;

      const html = await response.text();
      const wrapper = document.getElementById('shopify-section-cart-drawer-section');
      if (!wrapper) return;

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newSection = doc.getElementById('shopify-section-cart-drawer-section');

      if (newSection) {
        wrapper.innerHTML = newSection.innerHTML;
      }

      // Open the Theme Drawer
      const cartDrawer = document.querySelector('theme-drawer#cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }

      // Update cart count bubbles across the header and drawers
      const cartRes = await fetch('/cart.js');
      if (cartRes.ok) {
        const cartData = await cartRes.json();
        const count = cartData.item_count;

        // Update all badge text counts
        document.querySelectorAll(
          '[data-testid="cart-bubble"], [ref="cartBubbleCount"], .cart-bubble__text-count, .theme-drawer__badge, .cart-count-bubble, [data-cart-count]'
        ).forEach(function (badge) {
          badge.textContent = count;
          badge.classList.toggle('hidden', count === 0);
          badge.classList.toggle('visually-hidden', count === 0);
        });

        // Toggle container visibility
        document.querySelectorAll('.cart-bubble, cart-icon').forEach(function (bubble) {
          bubble.classList.toggle('visually-hidden', count === 0);
          bubble.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
        });
      }

      // Dispatch standard cart update events
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (err) {
      console.error('[Destiny Cart] Drawer sync error:', err);
    }
  }

  // 3. Listen for Add to Cart Button Clicks (Document Delegation)
  document.addEventListener('click', async function (event) {
    const btn = event.target.closest('[data-card-add-btn]');
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();

    // Prevent double submissions
    if (btn.classList.contains('is-loading')) return;

    let variantId = btn.getAttribute('data-variant-id');
    const card = btn.closest('[data-product-card]');

    // If button doesn't have variantId yet, check card variant selector
    if (!variantId && card) {
      const select = card.querySelector('[data-card-variant-select]');
      if (select && select.value) {
        variantId = select.value;
        btn.setAttribute('data-variant-id', variantId);
      }
    }

    if (!variantId) {
      console.warn('[Destiny Cart] No variant ID found for product card');
      return;
    }

    const btnTextEl = btn.querySelector('.destiny-product-card__btn-text') || btn;
    const originalText = btnTextEl.textContent.trim();

    btn.classList.add('is-loading');
    btnTextEl.textContent = 'ADDING...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      if (response.ok) {
        btnTextEl.textContent = '✓ ADDED';

        // Synchronize and slide out the cart drawer
        await syncAndOpenCartDrawer();

        setTimeout(function () {
          btnTextEl.textContent = originalText;
          btn.classList.remove('is-loading');
        }, 1800);
      } else {
        const errData = await response.json();
        btnTextEl.textContent = errData.description || 'UNAVAILABLE';
        setTimeout(function () {
          btnTextEl.textContent = originalText;
          btn.classList.remove('is-loading');
        }, 2200);
      }
    } catch (err) {
      console.error('[Destiny Cart] Add to cart error:', err);
      btnTextEl.textContent = 'ERROR';
      setTimeout(function () {
        btnTextEl.textContent = originalText;
        btn.classList.remove('is-loading');
      }, 2000);
    }
  });

  // Make syncAndOpenCartDrawer available globally
  window.destinySyncAndOpenCartDrawer = syncAndOpenCartDrawer;
})();
